import React, { useContext } from 'react';
import { format } from 'date-fns';
import { SummaryGrid } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';
import { CurrentApplicationContext } from '../../ApplicationOverview';

const translate = (key) => getTranslatedString(`landlordPortal.applicationManagement.${key}`);

const Summary = () => {
  const currentApplication = useContext(CurrentApplicationContext);

  const data = [
    [
      translate('applicationOverview.overview.leaseSummary.property'),
      currentApplication.lease?.property_name,
    ],
    [
      translate('applicationOverview.overview.leaseSummary.unit'),
      currentApplication.lease?.unit_number,
    ],
    [
      translate('applicationOverview.overview.leaseSummary.leaseStartDate'),
      currentApplication.lease?.lease_start_date &&
        format(new Date(currentApplication.lease?.lease_start_date), 'yyyy-MM-dd'),
    ],
    [
      translate('applicationOverview.overview.leaseSummary.leaseEndDate'),
      currentApplication.lease?.lease_start_date &&
        format(new Date(currentApplication.lease?.lease_end_date), 'yyyy-MM-dd'),
    ],
    [
      translate('applicationOverview.overview.leaseSummary.moveInDate'),
      currentApplication.lease?.lease_start_date &&
        format(new Date(currentApplication.lease?.early_move_in_date), 'yyyy-MM-dd'),
    ],
  ];

  return <SummaryGrid values={data} />;
};

export default Summary;
